export default "__VITE_ASSET__6Q6d2o51__"